import { useEffect, useMemo } from "react";
import { useAppContext } from "../contexts/AppContext";
import { initBingUet, parseBingUetTagId } from "../util/bingUet";

const BingUet: React.FC = () => {
    const { branding } = useAppContext();

    const tagId = useMemo(() => parseBingUetTagId(branding?.bingUetTagId), [branding?.bingUetTagId]);

    useEffect(() => {
        if (!tagId) return;
        initBingUet(tagId);
    }, [tagId]);

    return null;
};

export default BingUet;
